<template>
    <span>
        <router-link
            v-if="
                useRouter &&
                (patient.encoded_id || patient.encodedId) &&
                patientBusinessIsActive
            "
            :to="{
                name: 'patient_profile',
                query: showTab
                    ? {
                          tabName: showTab.tabName,
                          dropdown: showTab.dropdown,
                          status: showTab.status
                      }
                    : {},
                params: {
                    id: patient.encoded_id || patient.encodedId
                }
            }"
            :target="openNew ? '_blank' : '_self'"
        >
            {{ text || patient.name }}
            {{ showStatus ? getStatus(patient) : "" }}
        </router-link>
        <a
            v-else-if="!useRouter && patient.ci_url"
            :href="patient.ci_url || '#'"
            :target="openNew ? '_blank' : '_self'"
        >
            {{ text || patient.name }}
            {{ showStatus ? getStatus(patient) : "" }}
        </a>
        <a
            v-else-if="!useRouter && patient.encodedId"
            :href="CI_PATH + patient.encodedId"
        >
            {{ text || patient.name }}
            {{ showStatus ? getStatus(patient) : "" }}
        </a>
        <span v-else>
            {{ text || patient.name }}
            {{ showStatus ? getStatus(patient) : "" }}
        </span>
        <input
            type="hidden"
            name="patient-id"
            :value="patient.id ? patient.id : ''"
        />
    </span>
</template>

<script>
import PatientHelper from "@/mixins/patient";
import { has } from "lodash";

export default {
    mixins: [PatientHelper],
    name: "patientName",
    props: {
        patient: {
            type: Object,
            required: true
        },
        status: {
            type: Number,
            default: null
        },
        showStatus: {
            type: Boolean,
            default: true
        },
        showTab: {
            type: Object,
            default: null
        },
        /**
         * text: label shown. if not specified, patient.text will be used
         */
        text: {
            type: String,
            default: null
        },
        /**
         * useRouter: true = use react router push, false = use native anchor href
         */
        useRouter: {
            type: Boolean,
            default: true
        },
        openNew: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        patientBusinessIsActive() {
            // TODO: doing a refactor based on comment https://git.vettersoftware.com/dev/view/-/merge_requests/7966 when available.
            // not doing immediately as need to verify and test
            if (has(this.patient, "business_patient_isactive")) {
                return this.patient.business_patient_isactive;
            } else {
                return true;
            }
        }
    },
    data() {
        return {
            CI_PATH: `${process.env.CI_APPS}patient/patient/view/`
        };
    }
};
</script>
